import React from 'react';

const CardTileA = ({
    title,
    value,
    cardIcon,
    cardIconClass,
    smallText,
    smallTextClass = 'text-success',
    preText,
    borderColorClass,
    className
}) => {
    return (
        <div className={`metric-card border-bottom-${borderColorClass} ${className || ''}`}>
            <div className="metric-header">
                <span className="metric-title">{title}</span>
                <div className={`metric-icon-box bg-soft-${borderColorClass}`}>
                    <i className={`${cardIcon} ${cardIconClass}`}></i>
                </div>
            </div>
            
            <div className="metric-body">
                <div className="metric-value-container">
                    <span className="metric-main-value">{value}</span>
                    {smallText && (
                        <span className={`metric-trend ${smallTextClass}`}>
                            {smallText}
                        </span>
                    )}
                </div>
                
                {preText && (
                    <div className="metric-subtext">
                        {preText}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardTileA;